import { useEffect } from 'react';
import { watchKeyboard } from './lib/keyboard';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSession } from './app/session';
import { Loader, Screen } from './components/Chrome';
import { LoginScreen } from './screens/Login';
import { OnboardingScreen } from './screens/Onboarding';
import { HomeScreen } from './screens/Home';
import { WorkoutsScreen } from './screens/Workouts';
import { WorkoutScreen } from './screens/Workout';
import { TemplatesScreen } from './screens/Templates';
import { HistoryScreen } from './screens/History';
import { NutritionScreen } from './screens/Nutrition';
import { FoodSearchScreen } from './screens/FoodSearch';
import { FoodEditScreen } from './screens/FoodEdit';
import { FoodFormScreen } from './screens/FoodForm';
import { ScanScreen } from './screens/Scan';
import { LibraryScreen } from './screens/Library';
import { ArenaScreen } from './screens/Arena';
import { LeagueScreen } from './screens/League';
import { RulesScreen } from './screens/Rules';
import { ProfileScreen } from './screens/Profile';
import { PrivacyScreen } from './screens/Privacy';

export function App() {
  useEffect(watchKeyboard, []);
  const { status, user } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <Screen>
        <Loader label="Входим в джунгли…" />
      </Screen>
    );
  }

  if (status === 'anonymous' || !user) {
    return (
      <Routes>
        <Route path="*" element={<LoginScreen />} />
      </Routes>
    );
  }

  // Новый аккаунт сначала проходит знакомство (SPEC §4).
  if (!user.onboarded && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <Routes>
      <Route path="/onboarding" element={<OnboardingScreen />} />
      <Route path="/" element={<HomeScreen />} />

      <Route path="/workouts" element={<WorkoutsScreen />} />
      <Route path="/workouts/templates" element={<TemplatesScreen />} />
      <Route path="/workouts/history" element={<HistoryScreen />} />
      <Route path="/workouts/:id" element={<WorkoutScreen />} />

      <Route path="/nutrition" element={<NutritionScreen />} />
      <Route path="/nutrition/search" element={<FoodSearchScreen />} />
      <Route path="/nutrition/food" element={<FoodFormScreen />} />
      <Route path="/nutrition/scan" element={<ScanScreen />} />
      <Route path="/nutrition/library/:id/edit" element={<FoodEditScreen />} />
      <Route path="/nutrition/library" element={<LibraryScreen />} />

      <Route path="/arena" element={<ArenaScreen />} />
      <Route path="/arena/league" element={<LeagueScreen kind="personal" />} />
      <Route path="/arena/gym" element={<LeagueScreen kind="gym" />} />
      <Route path="/arena/rules" element={<RulesScreen />} />

      <Route path="/profile" element={<ProfileScreen />} />
      <Route path="/profile/privacy" element={<PrivacyScreen />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
